// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2yOXJ","requiredAsterisk":"Info_requiredAsterisk__3UzkY"};